import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import type { SettingItem } from '@news-cms/shared';
import { ApiError, api } from './api';
import { toast } from '@/components/ui/toaster';

export const settingsListQueryOptions = () =>
  queryOptions({
    queryKey: ['settings', 'list'] as const,
    queryFn: () => api<{ items: SettingItem[] }>('/api/admin/settings').then((d) => d.items),
    staleTime: 30_000,
  });

export function useUpdateSetting() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ key, value }: { key: string; value: unknown }) => {
      const data = await api<{ setting: SettingItem }>(
        `/api/admin/settings/${encodeURIComponent(key)}`,
        {
          method: 'PATCH',
          body: JSON.stringify({ value }),
        },
      );
      return data.setting;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['settings', 'list'] });
      toast.success('บันทึกการตั้งค่าเรียบร้อย');
    },
    onError: (e) => toast.error(settingErrorMessage(e)),
  });
}

export function settingErrorMessage(e: unknown): string {
  if (!(e instanceof ApiError)) return 'เกิดข้อผิดพลาด';
  switch (e.code) {
    case 'SETTING_NOT_FOUND':
      return 'ไม่พบการตั้งค่านี้';
    case 'FORBIDDEN':
      return 'คุณไม่มีสิทธิ์แก้การตั้งค่า';
    case 'VALIDATION_ERROR':
      return 'ค่าไม่ถูกต้อง';
    default:
      return e.message || 'เกิดข้อผิดพลาด';
  }
}
